export default __webpack_public_path__ + "static/blogOllips-417ba0e4bc00de41b8c91e73a0738479.png";